import { Box, styled } from '@planne-software/uni/mui/material';
import { buttonClasses } from '@planne-software/uni';
import { uni } from '@planne-software/uni/v2';
import { uniTypography } from '@src/fonts/typography/uniTypography';

export const CouponApplyWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-400'),
  width: '100%',
}));

export const CouponApplyRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'nowrap',
  gap: uni('scale-200'),
  width: '100%',
}));

export const CouponApplyInputWrapper = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
}));

export const CouponApplyButtonWrapper = styled(Box)(() => ({
  flexShrink: 0,

  [`& .${buttonClasses.root}`]: {
    minHeight: uni('scale-1000'),
    height: uni('scale-1000'),
  },
}));

export const CouponAffectedRoot = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-100'),
  width: '100%',
}));

export const CouponAffectedLabel = styled('span')`
  ${uniTypography('text-sm', 'medium')}
  color: ${uni('fg-neutral-static-default-body')};
`;

export const CouponAffectedChips = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: uni('scale-100'),
  width: '100%',
}));

export const CouponAffectedExpandRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
}));
